import { START_UPDATE_GENERAL_SUMMARY_REPORT } from '../types';

export const updateGeneralSummaryReport = payload => ({
    type: START_UPDATE_GENERAL_SUMMARY_REPORT,
    payload
})